<template>
  <!-- Cloud-only links (hidden in Electron Desktop) -->
  <router-link
    v-if="showSubscriptionLink"
    to="/subscription"
    class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/60"
    role="menuitem"
    tabindex="-1"
    @click="handleClose"
  >
    {{ t('app.nav.subscription') }}
  </router-link>
  <router-link
    v-if="showConfigurationLink"
    to="/configuration"
    class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/60"
    role="menuitem"
    tabindex="-1"
    @click="handleClose"
  >
    {{ t('app.nav.configuration') }}
  </router-link>
  <router-link
    id="user-menu-item-0"
    to="/profile"
    class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/60"
    role="menuitem"
    tabindex="-1"
    @click="handleClose"
  >
    {{ t('app.profile.view_profile') }}
  </router-link>
  <a
    id="user-menu-item-1"
    href="#"
    class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/60"
    role="menuitem"
    tabindex="-1"
    @click="handleLogout"
  >
    {{ t('app.actions.sign_out') }}
  </a>
  <div class="border-t border-gray-100 dark:border-gray-700 mt-1 pt-1 px-4 pb-1">
    <p class="text-[11px] leading-tight text-gray-400 dark:text-gray-500">
      {{ t('app.labels.version') }} {{ appVersion }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useI18n } from 'vue-i18n';
import { usePermissions } from '@/composables/usePermissions';
import { hasRestaurantContext } from '@/utils/subdomain';
import { useAppVersion } from '@/composables/useAppVersion';
import { platformFeatures } from '@/utils/platform';

interface Props {
  layout?: 'horizontal' | 'vertical';
}

const props = withDefaults(defineProps<Props>(), {
  layout: 'horizontal'
});

const emit = defineEmits<{
  close: [];
  logout: [];
}>();

const authStore = useAuthStore();
const { t } = useI18n();
const { canViewSubscription } = usePermissions();
const { appVersion } = useAppVersion();

const showSubscriptionLink = computed(() => {
  return platformFeatures.cloudOnly.subscription && 
         (authStore.user?.role === 'admin' || authStore.user?.role === 'sysadmin') && 
         hasRestaurantContext();
});

const showConfigurationLink = computed(() => {
  return platformFeatures.cloudOnly.subscription && 
         (authStore.user?.role === 'admin' || authStore.user?.role === 'sysadmin') && 
         hasRestaurantContext();
});

function handleClose() {
  emit('close');
}

function handleLogout() {
  emit('logout');
}
</script>
